'use client';

import React from 'react';

const Stats: React.FC = () => {
  const stats = [
    {
      label: 'Brand‑safe gamification',
      value: 'Built for modern brands',
      icon: (
        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 3l2.12 5.02L19.5 9l-4.05 3.46L16.5 18l-4.5-2.7L7.5 18l1.05-5.54L4.5 9l5.38-.98L12 3z"
          />
        </svg>
      ),
    },
    {
      label: 'Frictionless signup',
      value: 'Designed for conversion',
      icon: (
        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 6l6 6-6 6" />
        </svg>
      ),
    },
    {
      label: 'Actionable analytics',
      value: 'Built for insight',
      icon: (
        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 19h16" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V9" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 16V6" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16v-8" />
        </svg>
      ),
    },
    {
      label: 'Campaigns that scale',
      value: 'Ready as you grow',
      highlight: true,
      icon: (
        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2l3 7h7l-5.5 4 2.5 7L12 16l-7 4 2.5-7L2 9h7l3-7z" />
        </svg>
      ),
    },
  ];

  return (
    <section className="relative -mt-10 z-20 container mx-auto px-6">
      <div className="rounded-3xl p-2 bg-violet-700 shadow-2xl shadow-violet-500/20">
        <div className="rounded-[22px] bg-white/10 backdrop-blur-md ring-1 ring-white/20 p-4 md:p-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className={`group rounded-2xl px-4 py-4 md:px-5 md:py-5 bg-white/10 ring-1 ring-white/15 hover:bg-white/15 hover:ring-white/25 transition-colors`}
            >
              <div className="flex items-start gap-3">
                <div
                  className={`mt-0.5 h-10 w-10 rounded-xl flex items-center justify-center text-xl ${
                    stat.highlight ? "bg-emerald-400/15 ring-1 ring-emerald-300/20" : "bg-white/10 ring-1 ring-white/15"
                  }`}
                >
                  {stat.icon}
                </div>
                <div className="min-w-0">
                  <div className="text-base font-bold text-white tracking-tight leading-snug">
                    {stat.label}
                  </div>
                  <div className={`mt-1 text-sm leading-snug ${stat.highlight ? "text-emerald-100" : "text-white/80"}`}>
                    {stat.value}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
